import { createSelector } from '@reduxjs/toolkit';
import arrayUtils from '@utils/arrayUtils';
const getStores = (state) => state.storelocator.stores;
const getCurrentStoreId = (state) => state.storelocator.currentStoreId;
export const storesCount = createSelector([getStores], (stores) => stores === null || stores === void 0 ? void 0 : stores.length);
export const currentStoreSelector = createSelector([getStores, getCurrentStoreId], (stores, currentStoreId) => {
    return stores === null || stores === void 0 ? void 0 : stores.find((store) => store.ID === currentStoreId);
});
export const storesCitiesSelector = createSelector([getStores], (stores) => {
    return [...new Set(stores.map((store) => store.city))];
});
export const storesGroupByCountrySelector = createSelector([getStores], (stores) => {
    return arrayUtils.groupBy(stores, 'countryCode.value');
});
